import { configureStore } from '@reduxjs/toolkit';

import setting from './reducer/setting/slice';
import user from './reducer/user/slice';
import habitPack from './reducer/habit-pack/slice';
import admin from './reducer/admin/slice';
import adminTeams from './reducer/admin-teams/slice';
import cache from './reducer/cache/slice';
import focusMode from './reducer/focus-mode/slice';
import inquiry from './reducer/inquiry/slice';
import modal from './reducer/modal/slice';
import filter from './reducer/filter/slice';
import chatBot from './reducer/chat-bot/slice';
import general from './reducer/general/slice';
import procrastinate from './reducer/procrastinate/slice';
import toDo from './reducer/to-do/slice';
import platformIntegration from './reducer/platform-integration/slice';
import team from './reducer/team/slice';
import pagination from './reducer/pagination/slice';
import course from './reducer/course/slice';
import routineSuggestions from './reducer/routine-suggestions/slice';
import subscription from './reducer/subscription/slice';
import accountabilityBuddy from './reducer/accountability-buddy/slice';
import project from './reducer/project/slice';
import projectNote from './reducer/project-note/slice';
import note from './reducer/note/slice';
import mcpToken from './reducer/mcp-token/slice';
import portfolio from './reducer/portfolio/slice';
import dayPlan from './reducer/day-plan/slice';
import classManagement from './reducer/class-management/slice';
import classSession from './reducer/class-session/slice';
import stats from './reducer/stats/slice';
import managedBlocking from './reducer/managed-blocking/slice';

import { injectRoutineSuggestionMiddleware } from './middleware/inject-routine-suggestion.middleware';
import { classPresenceListenerMiddleware } from './listeners/class-presence.listener';

import { NODE_ENV } from 'constants/node-env';

export const store = configureStore({
  devTools: process.env.NODE_ENV === NODE_ENV.DEVELOPMENT,
  reducer: {
    setting,
    user,
    habitPack,
    admin,
    adminTeams,
    cache,
    focusMode,
    inquiry,
    modal,
    filter,
    chatBot,
    general,
    procrastinate,
    toDo,
    platformIntegration,
    team,
    pagination,
    course,
    routineSuggestions,
    subscription,
    accountabilityBuddy,
    project,
    projectNote,
    note,
    mcpToken,
    portfolio,
    dayPlan,
    classManagement,
    classSession,
    stats,
    managedBlocking
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      injectRoutineSuggestionMiddleware,
      classPresenceListenerMiddleware
    )
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
